import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const ReportFormView = React.lazy(() => import("../views/form/ReportForm"));

const ReportFormLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <ReportFormView />
  </React.Suspense>
);
export default () => <ReportFormLoadable />;
